document.addEventListener('alpine:init', () => {
  Alpine.data('QuantityStepper', () => {
    return {
      quantity: 1,
      init() {
        if (this.dropdownQuantity) {
          if (this.dropdownQuantity === '10+') {
            this.quantity = 10;
          } else {
            this.quantity = parseInt(this.dropdownQuantity, 10);
          }
        }
      },
      // The quantity box is written programmatically by parties other than this component: Avada
      // Order Limits sets the opening quantity, and the Foxkit shim re-asserts a tier minimum. A
      // programmatic assignment to .value fires no event, so x-model never hears it and `quantity`
      // silently desynchronises from the number the shopper can actually see. Stepping from that
      // stale copy is what took a wedding card from 25 to 2 rather than 26, so both buttons read
      // the box itself at the moment of the click.
      currentQuantity() {
        const parsed = parseInt(this.$refs.quantityInput?.value, 10);
        return Number.isNaN(parsed) ? this.quantity : parsed;
      },
      // Alpine writes the DOM on its own tick, so the value is set here rather than left to that
      // write: it guarantees the events below carry the intended number and not the previous one.
      // `input` is dispatched as well as `change` because `input` is the event a value change is
      // specified to fire, and it is the one the Foxkit shim listens for in order to stand down. A
      // stepper click is a real shopper edit, so the shim should stop re-asserting its tier the
      // moment it happens, which is what that shim's own comment already assumes happens today.
      setQuantity(next) {
        const input = this.$refs.quantityInput;
        this.quantity = next;
        if (!input) return;
        input.value = String(next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      },
      decreaseQuantity() {
        this.setQuantity(Math.max(1, this.currentQuantity() - 1));
      },
      increaseQuantity() {
        this.setQuantity(this.currentQuantity() + 1);
      },
    };
  });
});
